export const blobToArrayBuffer = (blob: Blob) => {
  return new Response(blob).arrayBuffer()
}
